<template>
  <div>
    <v-tooltip
      :disabled="$vuetify.breakpoint.xs"
      color="#DCD8F3"
      content-class="arrow-up"
      bottom
    >
      <template #activator="{ on: onTooltip }">
        <v-btn
          depressed
          light
          outlined
          :ripple="false"
          min-width="32px"
          height="32px"
          class="d-flex align-center justify-center theme-border-3 rounded mx-2"
          v-on="{ ...onTooltip }"
          @click="$emit('openSidebar')"
        >
          <v-icon
            size="20"
            class="ma-0 pa-0"
            :class="getBadgedStatus ? 'ml-1' : ''"
            :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
            >mdi-filter-outline</v-icon
          >

          <v-badge
            class="ml-1 mb-5"
            v-if="getBadgedStatus"
            color="red"
            dot
          ></v-badge>
        </v-btn>
      </template>
      <span class="font-weight-bold dark-purple-text">Apply Filter</span>
    </v-tooltip>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TaskFilters",
  computed: {
    ...mapGetters(["getBadgedStatus"]),
  },
};
</script>
<style scoped>
.dropdown-header {
  color: #6f7490 !important;
}
.radio-item input[type="radio"] {
  display: none;
}
.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 2px;
  margin: 0 5px 0 0;
  width: 14px;
  height: 14px;
  border-radius: 11px;
  border: 2px solid #1cc283;
  background-color: transparent;
}

.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 6px;
  height: 6px;
  position: relative;
  top: -14px;
  left: 8px;
  content: " ";
  display: block;
  background: #1cc283;
}
</style>
